module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fhead"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have had great assistance from the Oregon Historical Society, especially Elena Alvorado and Scott Rook; thank you for your time and work in assisting me with the fine photographs herein.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Rhonda Chambers for the use of her photo of Opal Whiteley’s mural.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pat Edwards is a partner in business and a great person to have on your side. Thanks, Pat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy Parrish and Jana Churchwell, many thanks for your assistance with Hazel Lee. Your work was very helpful, and I’m grateful for it. The help of Caroline D. Wilson from the Pentagon in researching Hazel Lee was also invaluable (and what fun to get e-mails from the actual Department of Defense!).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Katie Meakins for her service and for the inspiration to find out more about Hazel Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to my commissioning editor, Christen Thompson, for her help and support and to everyone at The History Press.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8c5382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 72
// module chunks = 0